import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { inchesToFeet, parseJSONError } from "legacy/helpers.es6"
import BoatForm from "legacy/new-reservation-form/BoatForm"
import PropTypes from "prop-types"
import React from "react"

class BoatChooser extends ApplicationComponent {
  constructor(props) {
    super(props)

    this.state = {
      boats: [],
      selectedBoat: props.selectedBoat,
      loadingBoats: false,
      errorMessage: props.errorMessage || null,
    }
    this.createBoat = this.createBoat.bind(this)
    this.submitBoat = this.submitBoat.bind(this)
    this.selectBoat = this.selectBoat.bind(this)
    this.getBoats = this.getBoats.bind(this)
    this.boatForm = null
    this.setBoatFormRef = (element) => {
      this.boatForm = element
    }
  }

  componentDidMount() {
    this.getBoats()
  }

  getBoats() {
    if (this.props.contact && this.state.boats.length === 0) {
      this.setState({ loadingBoats: true, errorMessage: null })
      $.get(
        `${$context.managePath}/contacts/${this.props.contact.encodedId}/contact_boats`,
        (response) => {
          const boats = response.data
          const boat =
            this.state.selectedBoat || (boats.length ? boats[0] : undefined)
          this.setState({
            loadingBoats: false,
            boats,
            selectedBoat: boat,
          })
        },
        "json"
      ).fail((data) => {
        const response =
          parseJSONError(data.responseText) ||
          "An error occurred while trying to fetch the contact's boats."
        this.setState({ loadingBoats: false, errorMessage: response })
      })
    }
  }

  selectBoat(event) {
    const selectedBoatID = event.target.value
    const selectedBoat = this.state.boats.find(
      (boat) => boat.id === parseInt(selectedBoatID)
    )
    this.setState({ selectedBoat })
  }

  selectBoatSection() {
    if (this.state.loadingBoats) {
      return (
        <div>
          <h3 className="bs-mt-0 bs-mb-4 font-semibold">Select Boat</h3>
          <div> Loading Contact&apos;s boats...</div>
        </div>
      )
    } else if (this.state.boats.length > 0) {
      return (
        <div>
          <h3 className="mb-4 mt-0 font-semibold">Select Boat</h3>
          <div className="flex space-x-4">
            <div className="-mb-5 flex-grow">
              <FormGroup
                inputType="select"
                value={
                  this.state.selectedBoat
                    ? this.state.selectedBoat.id
                    : undefined
                }
                name="selectedBoat"
                onChange={this.selectBoat}
              >
                {this.state.boats.map((boat) => (
                  <option key={boat.id} value={boat.id}>
                    {boat.name} - {boat.make} {inchesToFeet(boat.lengthOverall)}
                    &apos;
                  </option>
                ))}
              </FormGroup>
            </div>
            <LegacyButton
              type="primary"
              icon="fa-ship"
              iconStyle="solid"
              onClick={this.submitBoat}
            >
              Select Boat
            </LegacyButton>
          </div>

          <hr />
          <h2 className="center-text">OR</h2>
          <hr />
        </div>
      )
    }
    return null
  }

  createBoat() {
    const boatFormParams = this.boatForm.serialize()
    $.post(
      `${$context.managePath}/contacts/${this.props.contact.encodedId}/contact_boats`,
      boatFormParams,
      (data) => {
        this.setState({ selectedBoat: data })
        this.props.submitBoat(data)
      },
      "json"
    ).fail(() => {
      this.setState({ errorMessage: "There was a problem creating the boat." })
    })
  }

  submitBoat() {
    this.props.submitBoat(this.state.selectedBoat)
  }

  render() {
    return (
      <div>
        {this.state.errorMessage && <div>{this.state.errorMessage}</div>}
        {this.selectBoatSection()}
        <h3 className="mb-4 mt-0 font-semibold">
          Create Boat for {this.props.contact.name}
        </h3>
        <BoatForm ref={this.setBoatFormRef} onSubmit={this.createBoat} />
      </div>
    )
  }
}

BoatChooser.propTypes = {
  contact: PropTypes.object.isRequired,
  selectedBoat: PropTypes.object,
  errorMessage: PropTypes.string,
  submitBoat: PropTypes.func.isRequired,
}

export default BoatChooser
